import React from "react";
import { observer } from "mobx-react";
import { hiddenContentCheck } from "../../Helpers/General/HiddenContentHelper";
import { getSurveyResponseValue } from "../../Helpers/General/SurveyResponsesHelper";

const SurveyGridRow = observer((props) => {
    const { indexNum, isCompact, styleName, dependentQuestion, desiredValue } = props;
    let hide = hiddenContentCheck(props);

    // Check if row should be hidden based on dependent question
    const shouldHideRow = () => {
        if (!dependentQuestion) {
            return false;
        }
        var actualValue = getSurveyResponseValue(dependentQuestion, null);

        const actualStr = (actualValue ?? "").toString().toUpperCase();
        const desiredStr = (desiredValue ?? "").toString().toUpperCase();

        if (actualStr === desiredStr) {
            return false;
        }

        return true;
    };

    const rowClassName = () => {
        let className = styleName || "";
        // If the row has the compact class or the parent table has isCompact set to true
        if (isCompact || className.includes("compact-grid-row")) {
            className += " compact-grid-row";
        }
        return className.trim();
    };

    const renderCell = (child, colNum) => {
        if (!hide && !shouldHideRow() && !child?.props["hidden"]) {
            return (
                <td key={colNum} colSpan={props.colSpan} role="cell">
                    {child}
                </td>
            );
        }
        return null;
    };

    // If the entire row should be hidden, return null
    if (hide || shouldHideRow()) {
        return null;
    }

    return (
        <tr className={rowClassName()} role="row">
            {React.Children.map(props.children, (child, index) => 
                renderCell(child, index)
            )}
        </tr>
    );
});
        
export default SurveyGridRow;

